import { render, staticRenderFns } from "./editBankAffiliate.vue?vue&type=template&id=01758747&lang=pug"
import script from "./editBankAffiliate.vue?vue&type=script&lang=js"
export * from "./editBankAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports